export class ExternalUserModel {
    id?: number;
    login: string = '';
    name: string = '';
    surname: string = '';
    title: string = '';
    titleAfter: string = '';
    activeStatusCode?: string = '';
    personTypeCode?: string = '';
    employmentCode: string  = '';
    birthdate: string  = '';
    email: string  = '';
    phone: string  = '';
    workCenterName: string  = '';
    street: string  = '';
    postalCode: string  = '';
    city: string  = '';
    country: string  = '';
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/models/externalUser.model.ts